import React from 'react'
import useSingleStation from '../../hooks/useSingleStation'

export default function SingleStationCountryCity({idStation}: {idStation?: string} ) {

    const {singleStationQuery : {isLoading, isError, data}} = useSingleStation(idStation)


    isLoading && <>...</>
    isError && <>-</>

  return (
    <>
      {data?.station_city}, {data?.station_country}
    </>
  )
}
